import {DeviceInfoDto} from './DeviceInfoDto';
import {WebSocketMessage} from './WebSocketMessage';

export class WebSocketAuthenticationRequestDto extends WebSocketMessage {

    constructor(public language: string,
                public deviceInfo: DeviceInfoDto,
                public clientId: string,
                public botId: string,
                public overtakeConnection: boolean,
                public authToken?: string) {
        super(language, clientId, botId, undefined, undefined, authToken);
    }
}
